
import Vue from "vue";
import AppHighlightEdit from "./HighlightEdit.vue";
import { Highlight } from "@/utils/sale-edit/sale-edit-highlight";
import { SaleConfigs } from "@/models/dossier-configs/sale-configs";

export default Vue.extend({
	data(){
		return {
			toEditHighlight: null as null | Highlight,
			toEditIndex: -1
		};
	},
	props: {
		settings: {
			type: Object as ()=>SaleConfigs,
			required: true
		},
	},
	methods: {
		addClicked(){
			this.settings.SaleEditHighlightSettings.push(new Highlight());
			this.onEditCondition(this.settings.SaleEditHighlightSettings.length - 1);
		},
		removeHighlight(i:number){
			this.settings.SaleEditHighlightSettings.splice(i,1);
		},
		onEditCondition(i:number){
			this.toEditIndex = i;
			this.toEditHighlight = this.settings.SaleEditHighlightSettings[i];
		},
		onHighlightInput(highlight:Highlight){
			if (this.toEditIndex < 0) return;
			this.settings.SaleEditHighlightSettings[this.toEditIndex] = highlight;
		}
	},
	components: {
		AppHighlightEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
